/* eslint-disable no-param-reassign */
/* eslint-disable react/no-unescaped-entities */
/* eslint-disable no-undef */
import React from 'react';
import { connect } from 'react-redux';
import {
  map, isEmpty, get, find, size, filter, partition, union, flatMap, groupBy, uniqBy,
} from 'lodash';
import moment from 'moment-timezone';
import Slide from '@material-ui/core/Slide';
import { SwipeableDrawer } from '@material-ui/core';
import { removeProFromList } from '../../Shared/Helpers';
import { decode } from '../Shared/encode';
import { HotJar, defaultErrorMessage } from '../../../constants';
import {
  seBookingPAPView, seBookingPAPConfirm,
  sePickAProSelect, sePickAProUnselect,
} from '../../Shared/WebAnalytics';
import CTAButton from '../../Shared/CTAButton';
import { setBookingFlowStep, setCart, setBookingFlowPreviousStep } from '../../../Actions';
import '../Assets/Styles/index.css';
import './Assets/Styles/ProviderPickStep.css';
import ProCard from './ProCard';
import { STEPS } from '../Shared/constants';
import { removePro, requestPro } from '../Shared/helpers';

HotJar();

class Index extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      providers: [],
      currentStepId: 'TIMING',
      width: window.innerWidth,
      selectedProviders: [],
      instantConfirm: null,
    };
    this.goToNextStep = this.goToNextStep.bind(this);
    this.listAllPros = this.listAllPros.bind(this);
    this.removeProAndNext = this.removeProAndNext.bind(this);
    this.errorHandler = this.errorHandler.bind(this);
    this.skipButton = this.skipButton.bind(this);
    this.hasPAP2 = this.hasPAP2.bind(this);
    this.showHideCTA = this.showHideCTA.bind(this);
    this.addPro = this.addPro.bind(this);
    this.isProSelected = this.isProSelected.bind(this);
    this.defaultRemoveIC = this.defaultRemoveIC.bind(this);
    this.removeProFromSelection = this.removeProFromSelection.bind(this);
    this.submitList = this.submitList.bind(this);
    this.getSelectedTimeSlots = this.getSelectedTimeSlots.bind(this);
  }

  getSelectedTimeSlots(providerId) {
    // Returns array of selected time slots for a given provider ID
    const selectedForProvider = filter(this.state.selectedProviders, (sp) => sp.id === providerId);
    return map(selectedForProvider, 'timeSlot');
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    window.addEventListener('resize', () => this.setState({ width: window.innerWidth }));
    const currStepId = get(this.props, 'bookingFlow.step.id', '');
    const relevantPrev = currStepId === 'PICKAPRO2' ? 'PICKAPRO' : 'TIMING';
    const providers = get(this.props, 'bookingFlow.availableTherapistsWithTimeSlots', []);
    const icSize = size(filter(providers, (ell) => (ell.isIC)));
    const notCouples = size(get(this.props, 'booking.cart.cartProducts', [])) === 1;
    const cart = get(this.props, 'booking.cart', null);
    const bkngDate = moment(get(cart, 'time.utc', ''));
    const nowDate = moment().tz(get(cart, 'time.timezone', ''));
    const previousStep = find(STEPS, (step) => (step.id === relevantPrev));
    this.props.setBookingFlowPreviousStep(previousStep);
    this.props.changeBackground('none');
    seBookingPAPView(size(providers), get(cart, 'id', ''), 'booking_23_variant', notCouples ? 'False' : this.hasPAP2() ? 'Same_Time' : 'Back_to_Back', {
      market: get(cart, 'address.market', ''),
      number_of_ga_pros: size(providers) - icSize,
      number_of_ic_pros: icSize,
      lead_time_selected: bkngDate.diff(nowDate, 'hours'),
      is_today: bkngDate.isSame(nowDate, 'day'),
      click_source: get(this.props, 'bookingFlow.comingFromStep', 'TIMING') === 'TIMING' ? 'Date_Screen' : 'Review_Screen',
      test_name: "jul_2024_booking_enhancements",
      test_value: get(this.props, "jul_2024_booking_enhancements", "")
    });
    this.defaultRemoveIC();
    this.setState({ currentStepId: get(this.props, 'bookingFlow.step.id', ''), providers, selectedProviders: get(this.props, 'booking.cart.cartProducts.0.pap_therapist_preferences', []) });
  }

  defaultRemoveIC() {
    const curr = get(this.props, 'booking.cart.cartProducts.0.pap_therapist_preferences', []);
    const ln = size(curr);
    const isAlreadyConfirmed = get(this.props, 'booking.instant_confirmation', false);
    if (ln === 1 && isAlreadyConfirmed) {
      const cartId = get(this.props, 'booking.cart.id', '');
      const cartProductId = get(this.props, 'booking.cart.cartProducts.0.id', '');
      removePro(cartId, cartProductId, get(this.props, 'fieldsHolder.csrfToken', ''), (response) => {
        this.props.assignToCart({
          cart: decode(response.data.cart),
          find_for_me: false,
          instant_confirmation: false,
        });
      });
    }
  }

  removeProFromSelection(therapist, subIt) {
    const cartId = get(this.props, 'booking.cart.id', '');
    const cartProductId = get(this.props, 'booking.cart.cartProducts.0.id', '');
    const loader = this.props.setLoaderFlag;
    const isIC = get(therapist, 'isIC', false);
    if (isIC) {
      if (loader) {
        loader(true);
      }
      removeProFromList(cartId, cartProductId, therapist.id, (response) => {
        this.props.assignToCart({ cart: decode(response.data.cart), find_for_me: false });
        sePickAProUnselect({
          ab_test_booking_flow: 'new_flow', market: get(this.props, 'booking.cart.address.market', ''), list_position: subIt + 1, rating_value: get(therapist, 'rating', 0), bookings_count: get(therapist, 'number_of_bookings', 0),
          test_name: "jul_2024_booking_enhancements",
          test_value: get(this.props, "jul_2024_booking_enhancements", "")
        });
        if (loader) {
          loader(false);
        }
      }, () => {
        if (loader) {
          loader(false);
        }
      });
    } else {
      // For GA providers, filter by ID only (since they don't have timeSlot when using Select button)
      const therapistId = get(therapist, 'id', '');
      const therapistTimeSlot = get(therapist, 'timeSlot', '');
      
      this.setState({ 
        selectedProviders: filter(this.state.selectedProviders, (el) => {
          // If therapist has a timeSlot, match both ID and timeSlot
          // If therapist doesn't have a timeSlot, match only by ID
          if (therapistTimeSlot) {
            return !(el.id === therapistId && el.timeSlot === therapistTimeSlot);
          } else {
            return el.id !== therapistId;
          }
        })
      });
      sePickAProUnselect({
        ab_test_booking_flow: 'new_flow', market: get(this.props, 'booking.cart.address.market', ''), list_position: subIt + 1, rating_value: get(therapist, 'rating', 0), bookings_count: get(therapist, 'number_of_bookings', 0),
        test_name: "jul_2024_booking_enhancements",
        test_value: get(this.props, "jul_2024_booking_enhancements", "")
      });
    }
  }

  hasPAP2() {
    const backToBackAvailable = get(this.props, 'booking.cart.backToBack.available', false);
    const backToBackEnabled = get(this.props, 'booking.cart.backToBack.enabled', false);
    return backToBackAvailable && !backToBackEnabled;
    // we're not allowing pap2 for back to back.. users can always use rebook if any
  }

  errorHandler(err) {
    const loader = this.props.setLoaderFlag;
    if (loader) {
      loader(false);
    }
    this.props.displayError(get(err, 'response.data.errors.0.message', defaultErrorMessage));
  }

  goToNextStep(nextStepId = 'REVIEW') {
    const currStepId = get(this.props, 'bookingFlow.step.id', '');
    nextStepId = currStepId === 'PICKAPRO' && this.hasPAP2() ? 'PICKAPRO2' : nextStepId;
    const nextStep = find(STEPS, (step) => (step.id === nextStepId));
    this.props.setBookingFlowStepThroughParent(nextStep);
  }

  removeProAndNext() {
    const cartId = get(this.props, 'booking.cart.id', '');
    const currStepId = get(this.props, 'bookingFlow.step.id', '');
    const cartProductId = currStepId === 'PICKAPRO2' ? get(this.props, 'booking.cart.cartProducts.1.id', '') : get(this.props, 'booking.cart.cartProducts.0.id', '');
    removePro(cartId, cartProductId, get(this.props, 'fieldsHolder.csrfToken', ''), (response) => {
      this.props.assignToCart({ cart: decode(response.data.cart), find_for_me: true });
      this.goToNextStep();
    }, this.errorHandler);
  }

  skipButton() {
    return (
      <div className='col-xs-12'>
        <div className="mb-24 sm-mb-16 contentPrimary size-24-32 medium-font">
          Book with first available
        </div>
        <div className="br-rd-16 p-16 br-opaque mb-24 sm-mb-16 bg-primary">
          <div className="size-16-24 contentSecondary mb-12">
            Send a request to all qualified Providers in our network who match
            your preferences.
          </div>
          <button
            type="button"
            className="btn md-cta-quaternary p-10-12-imp width-auto"
            onClick={this.removeProAndNext}
          >
            Find a provider for me
          </button>
        </div>
      </div>
    );
  }

  listAllPros() {
    const { providers } = this.state;
    // example of providers here
    // {"8:00":[{provider1}, {provider2}], "9:00":[{provider1}]}
    if (!isEmpty(providers)) {
      // Flatten providers and collect time slots for each provider
      const allProvidersWithTimeSlots = flatMap(providers, (providerArray, timeSlot) => 
        map(providerArray, (provider) => ({ ...provider, timeSlot }))
      );
      
      // Group by provider ID to remove duplicates
      const groupedByProvider = groupBy(allProvidersWithTimeSlots, 'id');
      
      // Create unique provider objects with all their available time slots
      const uniqueProviders = map(groupedByProvider, (providerInstances) => {
        const provider = providerInstances[0]; // Get base provider data
        const timeSlots = map(providerInstances, 'timeSlot'); // Collect all time slots
        return { ...provider, availableTimeSlots: timeSlots };
      });
      
      // Separate IC and GA providers
      // For IC providers with backup ranges, check if they have any available times within those ranges
      // If not, treat them as GA providers
      const backup_ranges = get(this.props, 'booking.cart.info_fields.backup_ranges', []);
      const backup_ranges_enabled = get(this.props, 'booking.cart.info_fields.backup_ranges_enabled', false);
      
      const [trueSet, falseSet] = partition(uniqueProviders, (item) => {
        if (!item.isIC) return false;
        
        // If this is an IC provider with backup ranges enabled, check if they have available times
        if (backup_ranges_enabled && !isEmpty(backup_ranges)) {
          // Extract all backup range start times and convert to 24-hour format
          const backupTimes = map(backup_ranges, (range) => range.start_time);
          const backupTimes24h = map(backupTimes, (time) => moment(time, 'h:mm A').format('HH:mm'));
          
          // Check if there's any intersection between backup times and available time slots
          const hasAvailableTimes = backupTimes24h.some((time) => item.availableTimeSlots.includes(time));
          
          // If no available times in the backup ranges, treat as GA
          if (!hasAvailableTimes) {
            return false;
          }
        }
        
        return true;
      });
      const gaSize = size(falseSet);
      const gaAllowed = get(this.props, "booking.cart.info_fields.ga_pap_enabled", false) || true;
      let counter = -1;
      return (
        <>
          <div className="medium-font size-44-52 txt-center sm-size-28-36 color-black mb-4 mt-24 sm-txt-left">Select your provider{gaAllowed ? "s" : ""}</div>
            {backup_ranges_enabled ? (
              <div className="contentPrimary size-18-28 medium-font centered mb-36">
                {get(this.props, 'booking.cart.date.display', '')}
                ,
                {' '}
                Between{' '}
                {get(this.props, 'booking.cart.info_fields.range_start_by', '')}
                -
                {' '}
                {get(this.props, 'booking.cart.info_fields.range_end_by', '')}
              </div>
            )
            :<div className="contentPrimary size-18-28 medium-font mb-36">
              {get(this.props, 'booking.cart.date.display', '')}
              ,
              {' '}
              {get(this.props, 'booking.cart.time.display', '')}
            </div>}
          <div className="row">
            {isEmpty(trueSet) ? null : <>
            <div className="col-xs-12 mb-8">
              <div className="d-flex-only align-items-center">
                <div className="contentPrimary size-24-32 medium-font mr-4">Instant Book</div>
                <div className="label-xs-lavender-ash">Recommended</div>
              </div>
            </div>
            <div className="col-xs-12 mb-24 sm-mb-16 contentSecondary size-16-24">Your booking will be instantly accepted by the Provider you select.</div>
            {map(trueSet, (pro, subIt) => (
              <div key={`therapist-${subIt}-ic`} className="col-xs-12 mb-24 sm-mb-16 col-sm-4">
                <ProCard
                  therapist={pro}
                  errorHandler={this.errorHandler}
                  width={this.state.width}
                  updateParentState={(ther, timeSlot) => this.addPro({ ...ther, timeSlot }, subIt)}
                  removeProFromList={(ther) => this.removeProFromSelection(ther, subIt)}
                  availableTimeSlots={pro.availableTimeSlots}
                  backupRanges={get(this.props, 'booking.cart.info_fields.backup_ranges', [])}
                  isIC={pro.isIC}
                  getSelectedTimeSlots={this.getSelectedTimeSlots}
                />
              </div>
            ))}
            </>}
            {gaAllowed && !isEmpty(falseSet) ? <>
            <div className="col-xs-12 mb-8 contentPrimary size-24-32 medium-font">Request to Book between {get(this.props, 'booking.cart.info_fields.range_start_by', '')} - {get(this.props, 'booking.cart.info_fields.range_end_by', '')}</div>
            <div className="col-xs-12 mb-24 sm-mb-16 contentSecondary size-16-24">Book by sending a request to Providers. Your booking will be confirmed if a Provider accepts.</div>
              {map(falseSet, (pro, subIt) => {
                if (gaSize > 3) {
                  counter += 1;
                }
                return (
                  <div key={`therapist-${subIt}-ga`} className="display-contents">
                    {gaSize > 3 && counter === 3
                      ? (
                        <div className="col-xs-12 mb-24 col-sm-4 sm-mb-16">
                          {this.skipButton()}
                        </div>
                      ) : null}
                    <div className="col-xs-12 mb-24 sm-mb-16 col-sm-4">
                      <ProCard
                        therapist={pro}
                        errorHandler={this.errorHandler}
                        width={this.state.width}
                        updateParentState={(ther, timeSlot) => this.addPro({ ...ther, timeSlot }, subIt + size(trueSet))}
                        removeProFromList={(ther) => this.removeProFromSelection(
                          ther,
                          subIt + size(trueSet),
                        )}
                        availableTimeSlots={pro.availableTimeSlots}
                        backupRanges={[]}
                        isIC={false}
                        getSelectedTimeSlots={this.getSelectedTimeSlots}
                      />
                    </div>
                  </div>
                );
              })}
              </>:null}
              {(gaSize <= 3 && !isEmpty(falseSet)) || isEmpty(falseSet)
                ? (
                  <div className="col-xs-12 mb-24 sm-mb-16 col-sm-4">
                    {this.skipButton()}
                  </div>
                ) : null}
            {gaAllowed ? null :
              <div className="col-xs-12 mb-24 sm-mb-16 col-sm-4">
                {this.skipButton()}
              </div>}
          </div>
        </>
      );
    }
    return null;
  }

  isProSelected(proId, timeSlot, isIC) {
    if (isIC) {
      return !isEmpty(find(get(this.props, 'booking.cart.cartProducts.0.pap_therapist_preferences', []), (el) => (el.id === proId)));
    }
    return !isEmpty(find(this.state.selectedProviders, (el) => (el.id === proId && el.timeSlot === timeSlot)));
  }

  addPro(therapist, subIt) {
    const cartId = get(this.props, 'booking.cart.id', '');
    const cartProductId = get(this.props, 'booking.cart.cartProducts.0.id', '');
    const loader = this.props.setLoaderFlag;
    const isIC = get(therapist, 'isIC', false);
    const cart = get(this.props, 'booking.cart', null);
    const bkngDate = moment(get(cart, 'time.utc', ''));
    const nowDate = moment().tz(get(cart, 'time.timezone', ''));
    const sessionDate = moment(get(this.props, 'booking.cart.date.utc', '')).format('YYYY-MM-DD');
    const therapistTimeSlot = get(therapist, 'timeSlot', get(cart, 'time.display', ''));
    if (isIC) {
      if (loader) {
        loader(true);
      }
      requestPro(cartId, cartProductId, {
        pro_ids: [get(therapist, 'id', '')],
        remove_enhancements: true,
        session_time: moment(`${sessionDate} ${therapistTimeSlot}`, 'YYYY-MM-DD hh:mm A').format('HH:mm'),
        remove_therapist_preferences: Boolean(isIC),
        session_date: sessionDate,
      }, get(this.props, 'fieldsHolder.csrfToken', ''), (response) => {
        if (loader) {
          loader(false);
        }
        this.props.assignToCart({
          cart: decode(response.data.cart),
          instant_confirmation: Boolean(isIC),
          find_for_me: false,
        });
        sePickAProSelect({
          ab_test_booking_flow: 'new_flow', market: get(this.props, 'booking.cart.address.market', ''), list_position: subIt + 1, rating_value: get(therapist, 'rating', 0), bookings_count: get(therapist, 'number_of_bookings', 0), is_ic: Boolean(isIC),
          test_name: "jul_2024_booking_enhancements",
          test_value: get(this.props, "jul_2024_booking_enhancements", "")
        });
        if (isIC) {
          seBookingPAPConfirm(therapist.id || '', subIt || 0, true, cartId, {
            ab_test_booking_flow: 'new_flow',
            market: get(this.props, 'booking.cart.address.market', ''),
            is_ic: true,
            number_of_ga_pros: size(filter(get(this.props, 'bookingFlow.availableTherapistsWithTimeSlots', []), (ell) => (!ell.isIC))),
            number_of_ga_pros_selected: 0,
            lead_time_selected: bkngDate.diff(nowDate, 'hours'),
            is_today: bkngDate.isSame(nowDate, 'day'),
            click_source: get(this.props, 'bookingFlow.comingFromStep', 'TIMING') === 'TIMING' ? 'Date_Screen' : 'Review_Screen',
            test_name: "jul_2024_booking_enhancements",
            test_value: get(this.props, "jul_2024_booking_enhancements", "")
          });
          this.goToNextStep();
        }
      }, this.errorHandler);
    } else {
      const selectedProviders = this.state.selectedProviders;
      this.setState({ selectedProviders: union(selectedProviders, [therapist]) });
      sePickAProSelect({
        ab_test_booking_flow: 'new_flow', market: get(this.props, 'booking.cart.address.market', ''), list_position: subIt + 1, rating_value: get(therapist, 'rating', 0), bookings_count: get(therapist, 'number_of_bookings', 0), is_ic: Boolean(isIC),
        test_name: "jul_2024_booking_enhancements",
        test_value: get(this.props, "jul_2024_booking_enhancements", "")
      });
    }
  }

  submitList() {
    const cartId = get(this.props, 'booking.cart.id', '');
    const cartProductId = get(this.props, 'booking.cart.cartProducts.0.id', '');
    const loader = this.props.setLoaderFlag;
    const cart = get(this.props, 'booking.cart', null);
    const bkngDate = moment(get(cart, 'time.utc', ''));
    const nowDate = moment().tz(get(cart, 'time.timezone', ''));
    const sessionDate = moment(get(this.props, 'booking.cart.date.utc', '')).format('YYYY-MM-DD');
    const availablePros = get(this.props, 'bookingFlow.availableTherapistsWithTimeSlots', []);
    const reqPros = this.state.selectedProviders;
    if (loader) {
      loader(true);
    }
    requestPro(cartId, cartProductId, {
      pro_ids: map(reqPros, (ell) => (ell.id)),
      remove_enhancements: true,
      session_time: moment(`${sessionDate} ${get(cart, 'time.display', '')}`, 'YYYY-MM-DD hh:mm A').format('HH:mm'),
      remove_therapist_preferences: false,
      session_date: sessionDate,
    }, get(this.props, 'fieldsHolder.csrfToken', ''), (response) => {
      if (loader) {
        loader(false);
      }
      this.props.assignToCart({
        cart: decode(response.data.cart),
        instant_confirmation: false,
        find_for_me: false,
      });

      seBookingPAPConfirm(size(reqPros) === 1 ? get(reqPros, '0.id', '') : '', 'n/a', true, get(cart, 'id', ''), {
        ab_test_booking_flow: 'new_flow',
        market: get(cart, 'address.market', ''),
        is_ic: false,
        number_of_ga_pros: size(filter(availablePros, (pp) => (!pp.isIC))),
        number_of_ga_pros_selected: size(reqPros),
        lead_time_selected: bkngDate.diff(nowDate, 'hours'),
        is_today: bkngDate.isSame(nowDate, 'day'),
        click_source: get(this.props, 'bookingFlow.comingFromStep', 'TIMING') === 'TIMING' ? 'Date_Screen' : 'Review_Screen',
        test_name: "jul_2024_booking_enhancements",
        test_value: get(this.props, "jul_2024_booking_enhancements", "")
      });
      this.goToNextStep();
    }, this.errorHandler);
  }

  showHideCTA() {
    const ln = size(this.state.selectedProviders);
    const availablePros = get(this.props, 'bookingFlow.availableTherapistsWithTimeSlots', []);
    const total = size(availablePros);
    const isOnlyOneIC = get(find(availablePros, (elt) => elt.id === get(this.state, 'selectedProviders.0.id', '')), 'isIC', false);
    if (ln && !(ln === 1 && isOnlyOneIC)) {
      if (this.state.width < 800) {
        return (
          <SwipeableDrawer
            style={{ display: "contents" }}
            className="drawer-wrapper"
            PaperProps={{ style: { borderRadius: '16px 16px 0px 0px' } }}
            anchor="bottom"
            open
            swipeAreaWidth={56}
            disableSwipeToOpen
          >
            <div className="p-12-16">
              <div className="centered mb-8 contentPrimary size-16-20 medium-font">
                Request
                {' '}
                {ln}
                {' '}
                of
                {' '}
                {total}
                {' '}
                available
              </div>
              <div className="centered mb-8 contentSecondary size-12-20">Request more providers for faster acceptance; You'll be confirmed with the first one who accepts.</div>
              <button
                type="button"
                className="btn md-cta-primary"
                onClick={() => {
                  this.submitList();
                }}
              >
                Request selected providers
              </button>
            </div>
          </SwipeableDrawer>
        );
      }
      return (
        <div className="d-flex-only align-items-center justify-content-end bg-primary br-t-opaque shadow-top fixed-btm">
          <div className="contentPrimary size-16-20">
            <span className="tip-label mlr-5">Pro Tip</span>
            Appointment requests with at least 5 Providers are more likely to be accepted.
          </div>
          <CTAButton
            text={`Select ${ln === 1 ? '' : ln} and Continue`}
            additionalWrapperClass="br-top-none-imp"
            action={() => {
              this.submitList();
            }}
          />
        </div>
      );
    }
  }

  render() {
    return (
      <Slide direction="up" in mountOnEnter unmountOnExit>
        <div className="display-flex">
          <div className="maxW-75-vw m-auto sm-w-100 sm-p-24-16">
            <div className="sm-mb-150">
              {this.listAllPros()}
            </div>

            {this.showHideCTA()}
          </div>
        </div>
      </Slide>
    );
  }
}

const mapStateToProps = (state) => ({
  booking: state.booking,
  client: state.client,
  bookingFlow: state.bookingFlow,
  product: get(state, 'booking.product', null),
  fieldsHolder: state.fieldsHolder,
});

export default connect(mapStateToProps, {
  setBookingFlowStep,
  setCart,
  setBookingFlowPreviousStep,
})(Index);
